import React from 'react';
import { DEFAULT_THEME, THEME_PRESETS } from '../constants/theme';
import { applyClubTheme } from '../utils/theme';

function SiteThemeSettings({ API, club, clubs, isAllClubs, isSuperAdmin, setSiteTheme, setSiteThemeForm, showToast, siteThemeForm }) {
  return (
    <div className="w3-card w3-round w3-white w3-margin-bottom">
      <div className="w3-container w3-theme-d4 w3-round-top" style={{ padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ fontWeight: 700 }}><i className="fa fa-paint-brush w3-margin-right"></i>Site Default Theme</span>
        <button className="w3-button w3-tiny w3-theme-l2 w3-round" onClick={async () => {
          const r = await fetch(`${API}/api/auth/site-theme`, {
            method: 'PUT', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(siteThemeForm),
          });
          if (r.ok) {
            const saved = await r.json();
            if (setSiteTheme) setSiteTheme(saved);
            showToast('Site default theme saved');
          } else {
            const err = await r.json().catch(() => ({}));
            showToast(`Failed to save: ${err.error || r.status}`, 'red');
          }
        }}>
          <i className="fa fa-save w3-margin-right"></i>Save Site Theme
        </button>
      </div>
      <div className="w3-container w3-padding">
        <p className="w3-small w3-text-grey" style={{ margin: '0 0 10px' }}>
          This theme applies to all clubs that haven&apos;t set their own colours. Changing it updates the look for every user currently viewing &ldquo;All Clubs&rdquo; and any club using the default.
        </p>
        {/* Preset grid */}
        <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginBottom: '12px' }}>
          {THEME_PRESETS.map(p => (
            <button key={p.name} type="button" title={p.name}
              onClick={() => {
                setSiteThemeForm({ c60: p.c60, c30: p.c30, c10: p.c10 });
                applyClubTheme(p.c60, p.c30, p.c10);
              }}
              style={{
                display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px',
                padding: '6px 8px', border: '1px solid #ccc', borderRadius: '8px',
                background: '#fff', cursor: 'pointer', minWidth: '64px',
              }}>
              <div style={{ display: 'flex', gap: '3px' }}>
                <span style={{ width: 13, height: 13, borderRadius: '50%', background: p.c60, border: '1px solid #bbb', display: 'inline-block' }} />
                <span style={{ width: 13, height: 13, borderRadius: '50%', background: p.c30, border: '1px solid rgba(0,0,0,.08)', display: 'inline-block' }} />
                <span style={{ width: 13, height: 13, borderRadius: '50%', background: p.c10, border: '1px solid rgba(0,0,0,.08)', display: 'inline-block' }} />
              </div>
              <span style={{ fontSize: 'var(--gs-text-xs)', fontWeight: 600, color: '#555', whiteSpace: 'nowrap' }}>{p.name}</span>
            </button>
          ))}
        </div>
        {/* Fine-tune pickers */}
        <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', alignItems: 'flex-start' }}>
          {[
            { key: 'c60', label: '60% – Background', desc: 'Page bg & card surfaces (light/neutral)' },
            { key: 'c30', label: '30% – Navbar & Headers', desc: 'Main colour (dark/rich)' },
            { key: 'c10', label: '10% – Accent', desc: 'Buttons & active elements' },
          ].map(({ key, label, desc }) => (
            <div key={key} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <input type="color" value={siteThemeForm[key] || DEFAULT_THEME[key]}
                onChange={e => {
                  const val = e.target.value;
                  setSiteThemeForm(prev => {
                    const next = { ...prev, [key]: val };
                    applyClubTheme(next.c60, next.c30, next.c10);
                    return next;
                  });
                }}
                style={{ width: '44px', height: '36px', border: '1px solid #ccc', borderRadius: '6px', cursor: 'pointer', padding: '2px' }}
                title={desc}
              />
              <div>
                <div className="w3-tiny w3-text-grey" style={{ fontWeight: 700 }}>{label}</div>
                <div className="w3-tiny w3-text-grey">{desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default SiteThemeSettings;
